<template>
  <div class="xscontainer jsjiesh">
    <div class="shudiv">
      <div class="shudiv txcss">
        <img class="llig" src="@/assets/xxkc/txmn.png"/>
        <p class="biaoti4">{{gerenxinxi.xingming}}</p>
      </div>
    </div>
    <div class="shudiv">
      <div class="titdiv biaoti3_blue">
        基本信息
      </div>
      <div class="jbxx">
        <div class="kkstl">
          <div class="llcs"><p class="tt1">手机号码</p></div>
          <div class="tt2">{{gerenxinxi.sjh}}</div>
          <div class="tt3">修改</div>
          <div class="tt4">仅自己可见</div>
        </div>
        <div class="kkstl">
          <div class="llcs"><p class="tt1">个人邮箱</p></div>
          <div class="tt2">{{gerenxinxi.youxiang}}</div>
          <div class="tt3">修改</div>
          <div class="tt4">仅自己可见</div>
        </div>
        <div class="kkstl">
          <div class="llcs"><p class="tt1">所在地</p></div>
          <div class="tt2">{{gerenxinxi.suozaidi}}</div>
          <div class="tt3">修改</div>
        </div>
      </div>
    </div>
    <div class="shudiv">
      <div class="titdiv biaoti3_blue">
        报名课程
      </div>
      <div class="shudiv" style="padding:3rem 5rem;">
          <div class="div100 biaoti3">线上学习</div>
          <div class="clw">
            <div class="klsdf">
              <img  src="@/assets/xxkc/kc.png"/>
            </div>
            <div class="shudiv_center wzslh_wrap">
              <p class="biaoti3">数据治理实战能力认证培训-数据质量部分</p>
              <div class="hengdiv">
                <p class="zhengwen_grey">直播时间:2025年1月24日 18::00</p>
                <p class="zhengwen_grey">课程讲师:张天吧 大数据专家</p>
              </div>
            </div>
            <div class="ztcss">
              <span class="zttag">未完成</span>
            </div>
          </div>
          <div class="clw">
            <div class="klsdf">
              <img  src="@/assets/xxkc/kc.png"/>
            </div>
            <div class="shudiv_center wzslh_wrap">
              <p class="biaoti3">数据治理实战能力认证培训-数据质量部分</p>
              <div class="hengdiv">
                <p class="zhengwen_grey">直播时间:2025年1月24日 18::00</p>
                <p class="zhengwen_grey">课程讲师:张天吧 大数据专家</p>
              </div>
            </div>
            <div class="ztcss">
              <span class="zttag">未完成</span>
            </div>
          </div>
      </div>
    </div>
    <div class="shudiv">
      <div class="titdiv biaoti3_blue">
        报名课程
      </div>
      <div class="shudiv" style="padding:3rem 5rem;">
          <div class="div100 biaoti3">线下学习</div>
          <div class="clw">
            <div class="klsdf">
              <img  src="@/assets/xxkc/kc.png"/>
            </div>
            <div class="shudiv_center wzslh_wrap">
              <p class="biaoti3">数据治理实战能力认证培训-数据质量部分</p>
              <div class="hengdiv">
                <p class="zhengwen_grey">直播时间:2025年1月24日 18::00</p>
                <p class="zhengwen_grey">课程讲师:张天吧 大数据专家</p>
              </div>
            </div>
            <div class="ztcss">
              <span class="zttag">未完成</span>
            </div>
          </div>
          <div class="clw">
            <div class="klsdf">
              <img  src="@/assets/xxkc/kc.png"/>
            </div>
            <div class="shudiv_center wzslh_wrap">
              <p class="biaoti3">数据治理实战能力认证培训-数据质量部分</p>
              <div class="hengdiv">
                <p class="zhengwen_grey">直播时间:2025年1月24日 18::00</p>
                <p class="zhengwen_grey">课程讲师:张天吧 大数据专家</p>
              </div>
            </div>
            <div class="ztcss">
              <span class="zttag">未完成</span>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GerenKC',
  data() {
    return {
      gerenxinxi:{}
    }
  },
  mounted() {
    this.queryGerenxinxi();
  },
  methods: {
    queryGerenxinxi(){
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/tuser/tUser/list?_t='+new Date().getTime()+'&column=id&userid=zhaoqianqian1&order=asc&pageNo='+0+'&pageSize='+1)
          .then(function (response) {
            if (response.data.code == 200) {
              that.gerenxinxi  = response.data.result.records[0];
            } else {
              that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
            }
          });
    }
  }
}
</script>

<style  scoped>
.txcss{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.llig{
  width: 5rem;
  height: 5rem;
}
.titdiv{
  width: 100%;
  height: 2rem;
  background-color: #f0f7fd;
  display: flex;
  align-items: center;
  padding-left: 1rem;
}
.jbxx{
  margin-top: 1rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: 2rem;
}
.kkstl{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 3rem;
  justify-content: start;
}
.tt1{
  font-size: 1.1rem;
  color:black;
  font-weight: bold;
}
.tt2{
  width: 30%;
  font-size: 1.1rem;
  color:black;
}
.tt3{
  width: 10%;
  font-size: 1.1rem;
  color:#79a5e5;
}
.tt3:hover{
  cursor: pointer;
  color: #0b63e3;
}
.tt4{
  width: 20%;
  font-size: 1.1rem;
  color:grey;
}
.llcs{
  width: 20%;
  text-align: right;
}
.clw{
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap:1rem;
}
.statuscss{
  width: 20%;
}
.klsdf{
  max-width: 20rem;
  max-height: 10rem;
}
.zttag {
  width: 70px;
  height: 32px;
  line-height: 32px;
  border-radius: 25px;
  border: 1px solid #55a2da;
  color: #55a2da;
  display: flex;
  justify-content: center;
}
.ztcss{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
